module.exports = __webpack_public_path__ + "img/c6.1fbd6625.png";